<template>
  <div class="container">
    <div class="point_area">
      {{ point | comma }}
      <img src="@/assets/point_mark.png" alt="ポイントマーク">
      / 1回
    </div>
    <div class="graph">
      <!-- <div class="point">
        <img src="@/assets/point_mark.png" alt="ポイントマーク">
        {{ point | comma }}
      </div> -->
      <!-- <div class="bar" :style="{ width: barWidth + '%', backgroundColor: barColor }"></div> -->
      <div class="gauge">
        <img class="gauge_black" src="/img/gauge_black.png" alt="">
        <img class="gauge_red" v-if="barWidth == 0" src="/img/gauge_blank.png" alt="">
        <img class="gauge_red" v-if="barWidth != 0" src="/img/gauge_red.png" alt="" :style="{ 'clip-path': `polygon(0 0, ${barWidth}% 0, ${barWidth}% 100%, 0 100%)` }">
      </div>
    </div>
    <div class="remaining">
      <span class="remaining_text">残り</span>
      <span>{{ currentValue | comma }}</span>
      <span class="slash">/</span>
      <span>{{ maxValue | comma }}</span>
    </div>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';

export default {
  name: 'BarGraph',
  props: {
    maxValue: {
      type: [Number, String],
      default: 0,
    },
    currentValue: {
      type: [Number, String],
      default: 0,
    },
    point: {
      type: [Number, String],
      default: '',
    },
  },
  computed: {
    barWidth() {
      const currentValue = parseFloat(this.currentValue);
      const maxValue = parseFloat(this.maxValue);
      return (currentValue / maxValue) * 100 > 100 ? 100 : (currentValue / maxValue) * 100;
    },
    // 残りの数によってバーの色を変える
    // 50%以上: 緑, 30%以上: 黄色, それ以下: 赤
    // 一旦全て黒色を返すようにしています。
    barColor() {
      const currentValue = parseFloat(this.currentValue);
      const maxValue = parseFloat(this.maxValue);
      if ((currentValue / maxValue) > 0.5) {
        // return '#49ba86';
        return '#000';
      }
      if ((currentValue / maxValue) > 0.3) {
        // return '#ffb727';
        return '#000';
      }
      // return '#ef5656';
      return '#000';
    },
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(parseInt(value, 10));
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  font-family: Arial, sans-serif;
  width: 100%;
  padding-top: 15px;
  .point_area {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
      margin: 0 5px;
    }
  }
}
.graph {
  height: 20px;
  // border: 1px solid $gray;
  margin: 0 auto;
  position: relative;
  // border-radius: 15px;
}
.bar {
  height: 100%;
  position: absolute;
  left: 0;
  border-radius: 15px;
}
.gauge {
  position: relative;
  display: flex;
  align-items: center;
  height: 20px;
  img {
    width: 100%;
  }
  .gauge_red {
    left: 0;
    position: absolute;
    padding: 5px;
  }
}
.remaining_text {
  font-size: 12px;
}
.slash {
  margin: 0 5px;
}
.point {
  position: absolute;
  border: 2px solid #ffb727;
  width: 30%;
  top: -60%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: $white;
  img {
    position: absolute;
    top: 50%;
    left: -10%;
    transform: translate(0%, -50%);
    width: 20px;
    height: 20px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .container {
    .point_area {
      margin-bottom: 5px;
    }
  }
  .point {
    top: -40%;
    img {
      left: -15%;
      width: 15px;
      height: 15px;
    }
  }
  .graph {
    height: 8px;
  }
  .gauge {
    height: 10px;
  }
}
</style>
